import { FileEntryDownloadDto, PlaylistContentDownloadDto, PostDownloadDto } from 'collaboration-service';
import { Icon, Tooltip } from 'imaginarity-react-ui';
import * as React from 'react';
import { useAppSelector } from 'services/ApplicationState/ApplicationState';
import { getCMSContent } from 'services/Helpers/TranslationHelpers';
import { useImgI18N } from 'services/ImgI18N';
import { CSTitle, CSTitleBold, FileEntryHint } from './PlaylistEditClasses';
import { getPlaylistContentData } from './PlaylistEditContentImplementedElement';
import PlaylistEditPreviewElement from './PlaylistEditPreviewElement';
import { PlaylistEditSequenceLinearSC as T } from "./PlaylistEditSequenceLinearSC";
import { documentKindByType } from '../PlaylistItems/PlaylistNodeItem';

export interface PlaylistEditSequenceCurrentProps {
    post: PostDownloadDto;
    content: PlaylistContentDownloadDto;
    needsRef: boolean;
    selected: boolean;
    onSelect?: () => void;
    onSelectByTrainer?: () => void;
    onDelete?: () => void;
    isRef?: boolean;
    isTrainerRef?: boolean;
    onUp?: () => void;
    onDown?: () => void;
}

const PlaylistEditSequenceCurrent = (p: PlaylistEditSequenceCurrentProps) => {
    const contentLanguage = useAppSelector(s => s.contentLanguage);
    const { post, onSelect, onDelete, needsRef, selected, isRef, onUp, onDown, content, onSelectByTrainer, isTrainerRef } = p;
    const { t, currentLanguage } = useImgI18N("playlist");
    const language = contentLanguage ?? currentLanguage;
    const contentFE = post?.type === "FileEntry" ? getCMSContent({ fileEntry: post as FileEntryDownloadDto, filePosts: {}, language }) : undefined;
    const eleType = post?.type === "FileEntry" ? documentKindByType(contentFE?.media?.mediaType) : undefined;

    const { icon, title } = React.useMemo(() => {
        return getPlaylistContentData(content, language, post);
    }, [content, language, post]);

    const sanitizedTitle = title.replace(/<\/?p>/g, '');
    const typeIsFileEntry = post.type === "FileEntry";

    return (
        <>
            <CSTitle className='itemIcon'><Icon name={icon} /></CSTitle>
            <CSTitle>
                {typeIsFileEntry &&
                    <>
                        <FileEntryHint>
                            {t(post.type ?? "unknown")}
                        </FileEntryHint>
                        <Icon name="chevron right" size="12px" style={{ float: "left", marginTop: 2, marginLeft: -5 }} />
                    </>
                }
                {t(eleType ?? post.type ?? "unknown")}
            </CSTitle>
            <CSTitle className='itemIcon' title={sanitizedTitle}>
                {sanitizedTitle}
                {isRef &&
                    <Icon name="chevron right double" style={{ float: "left", marginRight: 5 }} />
                }
            </CSTitle>
            <div className={needsRef ? 'selArea' : 'selAreaInv'}>
                {needsRef && selected &&
                    <Tooltip tooltipText={onSelect !== undefined ? t("set this item as reference") : t("this is the reference")}>
                        <T.NodeButton onClick={onSelect}>
                            <Icon name={isRef ? "checkbox checked" : "checkbox unchecked"} />
                        </T.NodeButton>
                    </Tooltip>
                }
            </div>
            <div className='iconArea'>
                {onSelectByTrainer && selected &&
                    <Tooltip
                        tooltipText=""
                        tooltipContent={<div style={{ textAlign: "left" }}>
                            <CSTitleBold>
                                {isTrainerRef ? t("currently trainer action") : t("currently user action")}
                            </CSTitleBold>
                            {isTrainerRef ? t("click to toggle this item as to complete by user") : t("click to toggle this item as to complete by trainer")}
                        </div>}
                    >
                        <T.NodeButton onClick={onSelectByTrainer}>
                            <Icon name={isTrainerRef ? "education" : "user"} />
                        </T.NodeButton>
                    </Tooltip>
                }
            </div>
            <div className='iconArea'>
                {onDelete !== undefined && selected &&
                    <Tooltip tooltipText={t("remove item from phase")}>
                        <T.NodeButton onClick={onDelete}>
                            <Icon name="times" />
                        </T.NodeButton>
                    </Tooltip>
                }
            </div>
            <div className='iconArea'>
                {selected && onUp &&
                    <Tooltip tooltipText={t("move item up")}>
                        <T.NodeButton onClick={onUp}>
                            <Icon name="chevron up double" />
                        </T.NodeButton>
                    </Tooltip>
                }
            </div>
            <div className='iconArea'>
                {selected && onDown &&
                    <Tooltip tooltipText={t("move item down")}>
                        <T.NodeButton onClick={onDown}>
                            <Icon name="chevron down double" />
                        </T.NodeButton>
                    </Tooltip>
                }
            </div>
            <div className='iconArea'>
                {onDelete !== undefined && selected && <PlaylistEditPreviewElement post={post} />}
            </div>


        </>
    );
}

export default PlaylistEditSequenceCurrent;